<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :show-close="true"
    theme="info"
    :showIcon="false"
    :showTitle="false"
    width="80%"
    destroy-on-close
    class="tg-service-dialog"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-if="visible" class="tg-service-dialog--iframe">
      <iframe :src="src" ref="iframe"></iframe>
    </div>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  data() {
    return {
      visible: false,
    };
  },
  props: {
    src: String,
  },
  computed: {},
  methods: {
    showDialog() {
      this.visible = true;
    },
    handleMessage(e) {
      let action = e.data;
      //關閉iframe
      if (action == "close_service") {
        this.visible = false;
        this.$store.commit("service/update", { showServiceIframe: false });
      }
    },
  },
  created() {
    window.addEventListener("message", this.handleMessage, false);
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessage);
  },
};
</script>
